<ion-app>
  <ion-content>
    <ion-router-outlet id="microfe-main-content" [animated]="false">
    </ion-router-outlet>
  </ion-content>
</ion-app>